import {
  ODataDateTime,
  ODataHeader,
  ODataString,
  ODataDate,
} from "pbas-vue-components";


const OptOutsHeaders=[
  new ODataHeader({
 type: new ODataString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "First Name",
    type: new ODataString("FirstName"),
    sortable: false,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "Last Name",
    type: new ODataString("LastName"),
    sortable: false,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "Certificate",
    type: new ODataString("Certificate"),
    sortable: false,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "DoB",
    type: new ODataDate("DateOfBirth"),
    sortable: true,
    visible: true,
    searchable: false
  }),
  new ODataHeader({
    title: "Address",
    type: new ODataString("Address"),
    sortable: false,
    visible: true,
    searchable: false
  }),
  new ODataHeader({
    title: "Email",
    type: new ODataString("EmailAddress"),
    sortable: false,
    visible: true,
    searchable: true
  }),
    new ODataHeader({
    title: "Phone",
    type: new ODataString("PhoneNumber"),
    sortable: false,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "Date",
    type: new ODataDateTime("CreatedAt"),
    sortable: true,
    visible: true,
    searchable: false,
    orderByKey: "CreatedAt",
  }),
  new ODataHeader({
    title: "Submission Id",
    type: new ODataString("SubmissionId"),
    isIdentifier: true,
    sortable: false,
    visible: true,
    searchable: false,
  }),
  new ODataHeader({
    title: "Coverages",
    type: new ODataString("OptOuts/CoverageGroup/Name"),
    sortable: false,
    visible: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Institution Number",
    type: new ODataString("InstitutionNumber"),
    sortable: false,
    visible: true,
    searchable: true,
  }),
    new ODataHeader({
    title: "Insurance Company",
    type: new ODataString("OptOuts/InsuranceCompanyName"),
    sortable: false,
    visible: true,
    searchable: true
  }),
    new ODataHeader({
    title: "Policy Number",
    type: new ODataString("OptOuts/PolicyNumber"),
    sortable: false,
    visible: true,
    searchable: true
  }),  
  new ODataHeader({
    title: "Account Number",
    type: new ODataString("AccountNumber"),
    sortable: false,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "Transit Number",
    type: new ODataString("TransitNumber"),
    sortable: false,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "OptOut Id",
    type: new ODataString("OptOuts/Id"),
    sortable: false,
    visible: false,
    searchable: false,
  }),
]
export default OptOutsHeaders;